/* featureTypesSlice.ts */

/* Redux Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Thunks */
import { fetchFeatureTypes } from "src/redux/thunks/custom-cohorts/featureTypesThunk";

/* Interfaces */
import { BaseSliceProps } from "src/shared/interfaces/common/Slice";
import { BasicProps } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

const initialState: BaseSliceProps<BasicProps[]> = {
  data: undefined,
  isLoading: false,
  error: undefined,
};

export const featureTypesSlice = createSlice({
  name: "/options/features/types",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFeatureTypes.pending, (state) => {
      if (state.data === undefined) {
        state.isLoading = true;
      }
    });
    builder.addCase(
      fetchFeatureTypes.fulfilled,
      (
        state,
        action: PayloadAction<BasicProps[] | undefined>
      ) => {
        state.data = action.payload;
        state.isLoading = false;
      }
    );
  },
});

/* Reducer */
export default featureTypesSlice.reducer;
